/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 * Ключевая фраза класса МКТУ
 * @export
 * @interface MktuClassWord
 */
export interface MktuClassWord {
  /**
   * UUID фразы
   * @type {string}
   * @memberof MktuClassWord
   */
  uuid: string
  /**
   * Ключевая фраза класса МКТУ
   * @type {string}
   * @memberof MktuClassWord
   */
  word: string
  /**
   * Номер класса МКТУ (присутствует, когда загружена связь с классом)
   * @type {number}
   * @memberof MktuClassWord
   */
  classNumber?: number | null
  /**
   * Относится ли фраза к международному справочнику Ниццы
   * @type {boolean}
   * @memberof MktuClassWord
   */
  isNice: boolean
}

/**
 * Check if a given object implements the MktuClassWord interface.
 */
export function instanceOfMktuClassWord(value: object): value is MktuClassWord {
  if (!('uuid' in value) || value['uuid'] === undefined) return false
  if (!('word' in value) || value['word'] === undefined) return false
  if (!('isNice' in value) || value['isNice'] === undefined) return false
  return true
}

export function MktuClassWordFromJSON(json: any): MktuClassWord {
  return MktuClassWordFromJSONTyped(json, false)
}

export function MktuClassWordFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MktuClassWord {
  if (json == null) {
    return json
  }
  return {
    uuid: json['uuid'],
    word: json['word'],
    classNumber: json['classNumber'] == null ? undefined : json['classNumber'],
    isNice: json['isNice'],
  }
}

export function MktuClassWordToJSON(value?: MktuClassWord | null): any {
  if (value == null) {
    return value
  }
  return {
    uuid: value['uuid'],
    word: value['word'],
    classNumber: value['classNumber'],
    isNice: value['isNice'],
  }
}
